import axios from 'axios';
import { SetterOrUpdater } from 'recoil';
import { TTenant } from '../types/common';

export const getEmployeeMasterList = (
  furigana: string,
  current_page: number,
  display_limit: number = 0,
  employee_type: number = 0
) => {
  return axios
    .get(
      `/api/v1/all/users?furigana=${furigana}&display_limit=${display_limit}&page=${current_page}&employee_type=${employee_type}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const activateEmployeeById = (id: number) => {
  return axios
    .post(`/api/v1/activate/user/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
export const deleteEmployeeMaster = (users_list: any) => {
  return axios
    .post(
      `/api/v1/delete/users`,
      {
        users_list
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getCompanyGroups = () => {
  return axios
    .get(`/api/v1/groups`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createEmployeeMaster = (
  name: string,
  furigana: string,
  email: string,
  password: string,
  tel: string,
  group_ids: any,
  enrollment_status: number | undefined,
  department: string,
  occupation: string,
  position: string,
  remarks: string,
  role: number,
  partner_id: number
) => {
  return axios
    .post(
      `/api/v1/users`,
      {
        name,
        furigana,
        email,
        password,
        tel,
        group_ids,
        enrollment_status,
        department,
        occupation,
        position,
        remarks,
        role,
        partner_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 追加分の社員情報を保存
export const saveEmployeeBasic = (
  user_id: number,
  employee_id: string,
  employee_postal_code: string,
  employee_address: string,
  others_department: string,
  experience_start_date: string | null,
  join_date: string | null,
  retirement_date: string | null,
  date_of_birth: string | null,
  job_type: string,
  dependent_family: boolean,
  number_of_dependents: number,
  isEdit: boolean
) => {
  const method = isEdit ? 'put' : 'post';
  const url = isEdit ? `/api/v1/employee/${user_id}` : '/api/v1/employee';

  return axios({
    method: method,
    url: url,
    data: {
      user_id,
      employee_id,
      employee_postal_code,
      employee_address,
      others_department,
      experience_start_date,
      join_date,
      retirement_date,
      date_of_birth,
      job_type,
      dependent_family,
      number_of_dependents
    },
    headers: {
      withCredentials: true
    }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 社員顔写真追加
export const addFacePhoto = (user_id: any, file_obj: any) => {
  console.log('file_objapi', file_obj);
  return axios
    .post(`/api/v1/upload/employee/face-photo/${user_id}`, file_obj, {
      headers: {
        withCredentials: true,
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 社員顔写真取得
export const getFacePhoto = (user_id: any) => {
  return axios
    .get(`/api/v1/get/employee/face-photo/${user_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 社員顔写真削除
export const deleteFacePhoto = (user_id: any) => {
  return axios
    .delete(
      `/api/v1/delete/employee/face-photo/${user_id}`,

      {
        headers: {
          withCredentials: true,
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 緊急連絡先情報追加
export const addEmployeeEmergencyInfo = (
  user_id: number,
  emergency_contact_name: string,
  relationship: string,
  emergency_contact_phone: string,
  emergency_postal_code: string,
  emergency_contact_address: string
) => {
  return axios
    .post(
      `/api/v1/employee/emergency-info`,
      {
        user_id,
        emergency_contact_name,
        relationship,
        emergency_contact_phone,
        emergency_postal_code,
        emergency_contact_address
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 緊急連絡先情報取得
export const getEmployeeEmergencyInfoById = (user_id: number) => {
  return axios
    .get(`/api/v1/employee/emergency-info/${user_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 健康状態追加
export const addEmployeeHealthStatus = (
  user_id: number,
  health_insurance_enrollment: string,
  health_insurance_number: string,
  pension_enrollment: string,
  pension_number: string,
  employment_insurance_enrollment: string,
  employment_insurance_number: string,
  workers_comp_enrollment: boolean,
  sp_workers_comp_number: string,
  sp_workers_comp_date: string | null,
  retirement_aid_book: boolean,
  health_checkup_date: string | null,
  blood_type: string,
  min_blood_pressure: number,
  max_blood_pressure: number,
  blood_pressure_medication: string,
  sp_health_checkup_date: string | null,
  sp_health_checkup_type: string
) => {
  return axios
    .post(
      `/api/v1/employee/health-status`,
      {
        health_checkup_info: {
          user_id,
          health_checkup_date,
          blood_type,
          min_blood_pressure,
          max_blood_pressure,
          blood_pressure_medication,
          sp_health_checkup_date,
          sp_health_checkup_type
        },
        insurance_info: {
          user_id,
          health_insurance_enrollment,
          health_insurance_number,
          pension_enrollment,
          pension_number,
          employment_insurance_enrollment,
          employment_insurance_number,
          workers_comp_enrollment,
          sp_workers_comp_number,
          sp_workers_comp_date,
          retirement_aid_book
        }
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 健康状態取得
export const getEmployeeHealthStatusById = (user_id: number) => {
  return axios
    .get(`/api/v1/employee/health-status/${user_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

interface LicenceInfo {
  user_id: number;
  qualification_name: string;
  acquisition_date: string | null;
  renewal_date: string | null;
  expiration_date: string | null;
  qualification_type: string;
  remarks: string;
}

// 資格情報追加
export const editEmployeeCredentials = (
  user_id: number,
  driver_license_type: string,
  driver_license_number: string,
  licences: LicenceInfo[]
) => {
  return axios
    .post(
      `/api/v1/employee/credentials`,
      {
        entry_manage_info: {
          user_id,
          driver_license_type,
          driver_license_number
        },
        licences_info: licences
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 資格情報取得
export const getEmployeeCredentialsById = (user_id: number) => {
  return axios
    .get(`/api/v1/employee/credentials/${user_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getEmployeeMasterDetailsById = (id: number) => {
  return axios
    .get(`/api/v1/users/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const editEmployeeMaster = (
  id: number,
  name: string,
  furigana: string,
  email: string,
  tel: string,
  group_ids: any,
  enrollment_status: number | undefined,
  department: string,
  occupation: string,
  position: string,
  remarks: string,
  role: number,
  partner_id: number
) => {
  return axios
    .put(
      `/api/v1/users/${id}`,
      {
        name,
        furigana,
        email,
        tel,
        group_ids,
        enrollment_status,
        department,
        occupation,
        position,
        remarks,
        role,
        partner_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteEmployeeMasterById = (id: number) => {
  return axios
    .delete(`/api/v1/users/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getExportEmployeeItems = (
  selected_columns: any,
  furigana: string,
  employee_type: number = 0
) => {
  return axios
    .post(
      `/api/v1/export/users/list?furigana=${furigana}&employee_type=${employee_type}`,
      {
        selected_columns
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getExportCustomEmployeeItems = (employee_ids: any) => {
  return axios
    .post(
      `/api/v1/custom/export/users/list`,
      {
        users_list: employee_ids.arr // 選択されたユーザーIDのリスト
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getEmployeeMasterRoles = () => {
  return axios
    .get(`/api/get/all/roles/list`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getUserPermission = () => {
  return axios
    .get(`/api/get/users/roles`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getUserTenant = () => {
  return axios
    .get('/api/get/tenant/details', {
      headers: {
        withCredentials: true
      }
    })
    .then(async response => {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
